@if (ratingStats() && (totalReviews() ?? 0) >= 10) {
	<section class="sm:pb-8 md:bg-gray-50">
		<div class="container">
			<div
				class="grid grid-cols-1 border-b divide-y sm:gap-4 sm:divide-y-0 sm:grid-cols-2 xl:grid-cols-4 sm:border-b-0"
			>
				<!-- accommodation -->
				@if (ratingStats()?.accommodation) {
					<uc-university-information-card
						cardTitle="Accommodation"
						[value]="(ratingStats()?.accommodation | number: '1.2-2') + '/ 5'"
					>
						<uc-house-svg />
					</uc-university-information-card>
				}
				<!-- employability -->
				@if (ratingStats()?.graduate_careers) {
					<uc-university-information-card
						cardTitle="Employability"
						[value]="
							(ratingStats()?.graduate_careers | number: '1.2-2') + '/ 5'
						"
					>
						<uc-academic-cap-svg />
					</uc-university-information-card>
				}
				<!-- course quality -->
				@if (ratingStats()?.course_quality) {
					<uc-university-information-card
						cardTitle="Course Quality"
						[value]="
							(ratingStats()?.course_quality | number: '1.2-2') + '/ 5'
						"
					>
						<uc-open-book-svg />
					</uc-university-information-card>
				}
				<!-- student life -->
				@if (ratingStats()?.social_life) {
					<uc-university-information-card
						cardTitle="Student Life"
						[value]="(ratingStats()?.social_life | number: '1.2-2') + '/ 5'"
					>
						<uc-users-svg />
					</uc-university-information-card>
				}
			</div>
		</div>
	</section>
}
